import Heading from '@algbra/ui/components/Heading/Heading'
import Icon from '@algbra/ui/components/Icon/Icon'
import { getIconByName } from '@algbra/ui/icons'
import { useRef, useState } from 'react'
import styles from './Video.module.scss'

export type VideoFullScreenProps = {
  youtube_code: string
  onToggleVideo: () => void
}
export function VideoFullScreen({
  youtube_code,
  onToggleVideo,
}: VideoFullScreenProps) {
  return (
    <div className={styles.videoFixed}>
      <div className={styles.videoCloseBar}>
        <Icon
          icon={getIconByName('times')}
          className={styles.closeIcon}
          onClick={onToggleVideo}
        />
      </div>
      <iframe
        title="Algbra Decoded"
        style={{ border: 0 }}
        width="100%"
        height="100%"
        allow="autoplay; encrypted-media"
        src={`https://www.youtube.com/embed/${youtube_code}?&autoplay=1&rel=0`}
        allowFullScreen
      ></iframe>
    </div>
  )
}
